// Users can click on .-link elements to visit the href of an anchor tag inside that element
// (only in frontend)

const elementsThatShouldBeClickable = document.querySelectorAll('.-live .-link');

[...elementsThatShouldBeClickable].forEach(function(el) {
    const hrefEl = el.querySelector('a[href]');
    if (hrefEl) {
        const href = hrefEl.getAttribute('href');
        if (href) {
            el.style.cursor = 'pointer';
            el.addEventListener('click', function() {
                window.location = href;
            });
        }
    }
});


const elementsThatShouldBeClickableOnDesktop = document.querySelectorAll('.-live .-desktoplink');

[...elementsThatShouldBeClickableOnDesktop].forEach(function(el) {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (vw < 1400) {
        return;
    }
    
    const hrefEl = el.querySelector('a[href]');
    if (hrefEl) {
        const href = hrefEl.getAttribute('href');
        if (href) {
            el.style.cursor = 'pointer';
            el.addEventListener('click', function() {
                window.location = href;
            });
        }
    }
});
